export type BuildRequestType = 'build' | 'components' | 'upgrade';

export interface BuildOrderDraft {
  tasks: string;
  requestType: BuildRequestType;
  label: string;
}

let buildDraft: BuildOrderDraft | null = null;

export function setBuildOrderDraft(draft: BuildOrderDraft): void {
  buildDraft = {
    tasks: String(draft.tasks || '').trim(),
    requestType: draft.requestType,
    label: String(draft.label || '').trim()
  };
}

export function getBuildOrderDraft(): BuildOrderDraft | null {
  return buildDraft;
}

export function clearBuildOrderDraft(): void {
  buildDraft = null;
}
